/** @module csi/widget/FormGroupSelection*/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",

	"dojo/text!./FormGroupSelection.html",
	"csi/widget/CheckBox",
	"csi/widget/ValidationTextBox",
	"csi/widget/FilteringSelect"
], function(declare,lang,_TemplatedMixin,_WidgetBase,_WidgetsInTemplateMixin,template) {
	var FIELD_GROUP_CONTAINER = "csi-field-group-container";

	return declare([_WidgetBase,_TemplatedMixin,_WidgetsInTemplateMixin], {
		templateString: template,

		baseClass: "csi-form-group-selection",

		/** @property {string} checkboxLabel - the label for the checkbox */
		checkboxLabel: "",

		/** @property {Object} control - drop down control to insert in this widget */
		control: null,

		/** @property {string} currentValueLabel - the label for current value text box */
		currentValueLabel: "",

		/** @property {string} currentValue - current value */
		currentValue: "",

		/** @property {string} currentAdditionalText - the text to display under text box */
		currentAdditionalText: "",

		/** @property {string} dropdownLabel - the label for drop down widget*/
		dropdownLabel: "",

		/** @property {string} name - serve as key for the widget when _FormMixin get("value") function is called */
		name: "",

		/** @property {Store} store - the store for drop down widget*/
		store: null,

		/** @property {string} widgetUniqId - unique id to link checkbox and label (label attribute "for") */
		widgetUniqId: "",

		/** @property {string} value - value of the widget */
		value: null,


		/**
		 * Set  checkbox value of the widget
		 * @param {boolean} checked
		 */
		_onChangeCheck: function(checked) {
			this.onChangeCheck(checked);
		},

		/**
		 * Extension point
		 * @propert {checked} boolean
		 */
		onChangeCheck: function(checked){ },

		/**
		 * Set the value of the widget
		 * @param {string} value
		 */
		_onChangeValue: function(value) {
			this._set("value", value);
			this.onChangeValue(value);
		},

		/**
		 * Extension point
		 * @propert {CNL} value
		 */
		onChangeValue: function(value) { },

		_setControlAttr: function(control) {
			control.placeAt(this.dropdownNode, "replace");
			this.dropdownNode = control;
			control.onChange = lang.hitch(this,this._onChangeValue);
		},

		/**
		 * Set current value
		 */
		_setCurrentValueAttr: function(value) {
			this.currentNode.set("value", value);
			this._set("currentValue", value);
		}, 
		/**
		 * Set the dropdown value
		 * @param {string} value
		 */
		_setValueAttr: function(value) {
			this.dropdownNode.set("value", value);
		},

		/**
		 * Set the dropdown store
		 * @param {Store} store
		 */
		_setStoreAttr: function(store) {
			this._set("store", store);
			this.dropdownNode.set("store", store);
		}
	});
});
